import React from 'react';
import { Chip, Tooltip, Box, LinearProgress, Typography } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  Warning as WarningIcon,
  Schedule as ScheduleIcon
} from '@mui/icons-material';

interface PaymentStatusBadgeProps {
  status: string;
  isCompleted: boolean;
  percentage: number;
  paidAmount: number;
  totalDue: number;
}

const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({
  status,
  isCompleted,
  percentage,
  paidAmount,
  totalDue
}) => {
  if (isCompleted || status === 'paid') {
    return (
      <Tooltip title="Pago completado">
        <Chip
          icon={<CheckCircleIcon />}
          label="Completado"
          color="success"
          size="small"
        />
      </Tooltip>
    );
  }

  if (status === 'partial' || (paidAmount > 0 && !isCompleted)) {
    return (
      <Tooltip
        title={
          <Box>
            <Typography variant="caption">
              Pagado: {paidAmount} / {totalDue} RUB ({percentage}%)
            </Typography>
            <LinearProgress 
              variant="determinate" 
              value={percentage} 
              sx={{ mt: 0.5, height: 4 }}
            />
          </Box>
        }
        arrow
      >
        <Chip
          icon={<ScheduleIcon />}
          label={`Pago parcial (${percentage}%)`}
          color="warning"
          size="small"
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Pago pendiente">
      <Chip
        icon={<WarningIcon />}
        label="Pendiente"
        color="error"
        size="small"
      />
    </Tooltip>
  );
};

export default PaymentStatusBadge;